import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { PipesModule } from './../../pipes/pipes.module';

import { HelpLinkDirective } from './help-link.directive';
import { HelpLinkArticleResolverService } from './help-link-article-resolver.service';
import { HELP_LINK_ARTICLE_RESOLVER } from './help-link.domain';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    TranslateModule.forChild(),
    HelpLinkDirective
  ],
  exports: [
    HelpLinkDirective
  ],
  providers: [
    HelpLinkArticleResolverService,
    {
      provide: HELP_LINK_ARTICLE_RESOLVER,
      useExisting: HelpLinkArticleResolverService
    }
  ]
})
export class HelpLinkModule {
}
